import { Icon, IconSize, Settings, Tag } from '@soteria/design-system-ve';
import { useNavigate } from 'react-router-dom';

import * as styles from './Guide.css';

interface GuideSystemPagesProps {
  onClose: () => void;
}

/**
 * GuideSystemPages component
 * System administration pages for system admins only
 */
export function GuideSystemPages({ onClose }: GuideSystemPagesProps) {
  const navigate = useNavigate();

  const handlePageClick = (path: string) => {
    navigate(path);
    onClose();
  };

  return (
    <div className={styles.pagesList}>
      {/* Add Community Group */}
      <button aria-label="Add Community Group" className={styles.pageButton} type="button" onClick={() => handlePageClick('/community-groups')}>
        <Icon className={styles.pageIcon} icon={Settings} iconSize={IconSize.Small} />
        <span>Add Community Group</span>
      </button>

      {/* Manage Labels */}
      <button aria-label="Manage Labels" className={styles.pageButton} type="button" onClick={() => handlePageClick('/label-management')}>
        <Icon className={styles.pageIcon} icon={Tag} iconSize={IconSize.Small} />
        <span>Manage Labels</span>
      </button>
      {/* Manage Standard Policies */}
      <button aria-label="Manage Standard Policies" className={styles.pageButton} type="button" onClick={() => handlePageClick('/policy-management')}>
        <Icon className={styles.pageIcon} icon={Tag} iconSize={IconSize.Small} />
        <span>Manage Standard Policies</span>
      </button>
    </div>
  );
}
